import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function RestablecerPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setOk(false);

    if (!token) {
      setError('El enlace de recuperación no es válido.');
      return;
    }

    if (password.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }

    if (password !== password2) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('https://api.braineka.com/usuarios/restablecer-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'No se pudo restablecer la contraseña.');
      setOk(true);
      setPassword('');
      setPassword2('');
    } catch (err) {
      setError(err.message || 'No se pudo restablecer la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recuperar-container">
      <form className="recuperar-form" onSubmit={handleSubmit}>
        <h3>Restablecer contraseña</h3>
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={password}
          onChange={e => setPassword(e.target.value)}
          minLength={8}
          required
        />
        <input
          type="password"
          placeholder="Repetir nueva contraseña"
          value={password2}
          onChange={e => setPassword2(e.target.value)}
          minLength={8}
          required
        />
        <button type="submit" disabled={loading || !token}>
          {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
        </button>
        {ok && (
          <div className="recuperar-ok">
            Contraseña actualizada. Ya puedes volver al <Link to="/login">login</Link>.
          </div>
        )}
        {error && <div className="recuperar-error">{error}</div>}
        {!token && <div className="recuperar-error">Falta el token de recuperación.</div>}
      </form>
    </div>
  );
}
